import { Heading, Section } from 'components'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React from 'react'

const SectionBlock = ({ heading, text, buttons, featuredImage }) => {
  return (
    <Section>
      <div className="grid grid-cols-12 items-center gap-16">
        <div className="space-y-4 col-span-5">
          <Heading type="kicker">Something</Heading>
          <Heading className="text-7xl">{heading}</Heading>
          {/* <ParsedContent className="text-gray-500">{text}</ParsedContent> */}

          {/* <div className="flex flex-wrap w-full">
            {buttons.map((button) => (
              <Button
                key={button.label}
                type={button.type}
                to={button.destination.uri}
                isLg
              >
                {button.label}
              </Button>
            ))}
          </div> */}
        </div>
        <div className="col-span-7">
          {featuredImage && (
            <div className="rounded shadow-sm overflow-auto">
              {!featuredImage.localFile.childImageSharp ? (
                <img
                  src={featuredImage.localFile.publicURL}
                  alt={
                    featuredImage.altText
                      ? featuredImage.altText
                      : featuredImage.title
                  }
                ></img>
              ) : (
                <GatsbyImage
                  objectFit="cover"
                  alt={
                    featuredImage.altText
                      ? featuredImage.altText
                      : featuredImage.title
                  }
                  image={getImage(featuredImage.localFile)}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </Section>
  )
}

export default SectionBlock
